// 用于处理merge时无法遍历Date等对象的问题
var BUILTIN_OBJECT: any = {
  "[object Function]": 1,
  "[object RegExp]": 1,
  "[object Date]": 1,
  "[object Error]": 1,
  "[object CanvasGradient]": 1,
  "[object CanvasPattern]": 1,
  // For node-canvas
  "[object Image]": 1,
  "[object Canvas]": 1,
};

var TYPED_ARRAY: any = {
  "[object Int8Array]": 1,
  "[object Uint8Array]": 1,
  "[object Uint8ClampedArray]": 1,
  "[object Int16Array]": 1,
  "[object Uint16Array]": 1,
  "[object Int32Array]": 1,
  "[object Uint32Array]": 1,
  "[object Float32Array]": 1,
  "[object Float64Array]": 1,
};

/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */
export function isArray(value: any) {
  return objToString.call(value) === "[object Array]";
}

var objToString = Object.prototype.toString;
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */
export function isObject(value: any) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return type === "function" || (!!value && type === "object");
}

/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */
export function isBuiltInObject(value: any) {
  return !!BUILTIN_OBJECT[objToString.call(value)];
}

var primitiveKey = "__ec_primitive__";
export function isPrimitive(obj: any) {
  return obj[primitiveKey];
}

/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */
export function isDom(value: any) {
  return (
    typeof value === "object" &&
    typeof value.nodeType === "number" &&
    typeof value.ownerDocument === "object"
  );
}

/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */
export function clone(source: any) {
  if (source == null || typeof source != "object") {
    return source;
  }

  var result = source;
  var typeStr = objToString.call(source);

  if (typeStr === "[object Array]") {
    if (!isPrimitive(source)) {
      result = [];
      for (let i = 0, len = source.length; i < len; i++) {
        result[i] = clone(source[i]);
      }
    }
  } else if (TYPED_ARRAY[typeStr]) {
    if (!isPrimitive(source)) {
      var Ctor = source.constructor;
      if (source.constructor.from) {
        result = Ctor.from(source);
      } else {
        result = new Ctor(source.length);
        for (let i = 0, len = source.length; i < len; i++) {
          result[i] = clone(source[i]);
        }
      }
    }
  } else if (
    !BUILTIN_OBJECT[typeStr] &&
    !isPrimitive(source) &&
    !isDom(source)
  ) {
    result = {};
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = clone(source[key]);
      }
    }
  }

  return result;
}

/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */
export function merge(target: any, source: any, overwrite?: any) {
  if (!target) {
    return clone(source);
  }
  // We should escapse that source is string
  // and enter for ... in ...
  if (!isObject(source) || !isObject(target)) {
    return overwrite ? clone(source) : target;
  }

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      var targetProp = target[key];
      var sourceProp = source[key];

      if (
        isObject(sourceProp) &&
        isObject(targetProp) &&
        !isArray(sourceProp) &&
        !isArray(targetProp) &&
        !isDom(sourceProp) &&
        !isDom(targetProp) &&
        !isBuiltInObject(sourceProp) &&
        !isBuiltInObject(targetProp) &&
        !isPrimitive(sourceProp) &&
        !isPrimitive(targetProp)
      ) {
        // 如果需要递归覆盖，就递归调用merge
        merge(targetProp, sourceProp, overwrite);
      } else if (overwrite || !(key in target)) {
        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
        // NOTE，在 target[key] 不存在的时候也是直接覆盖
        target[key] = clone(source[key]);
      }
    }
  }

  return target;
}
